<template>
  <div
    class="napaItem flexAlignEnd"
    v-if="data"
    :style="{ 'background-color': objStatus.bgColor }"
  >
    <figure class="napaItemImage">
      <img src="/images/manager/matching/matching1.png" alt="" />
    </figure>
    <div class="napaItemText">
      <div>
        <h6 class="napaItemTitle">보낸 기업</h6>
        <h3 class="napaItemDesc">{{ data.requestedId }}</h3>
        <h6 class="napaItemTime">{{ data.regDate }}</h6>
      </div>
      <MainBadge title="NAP 자문 완료" :variant="objStatus.chipColor" />
    </div>

    <MainButton
      size="large"
      variant="contained"
      :btnText="objStatus.btnText"
      :color="objStatus.btnColor"
      @click="handleView"
    />

    <NapWritPopup
      :data="data"
      :isOpenModalNap="isShowNapWritPopup"
      :handleToggleModalNap="onCloseModal"
      @onReply="onReply"
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { napStatus } from "@/data/constances";
import MainBadge from "@/components/badge/MainBadge.vue";
import MainButton from "@/components/button/MainButton.vue";
import NapWritPopup from "./popup/NapWritPopup.vue";

export default {
  name: "ItemSentAdmin",
  components: {
    MainButton,
    MainBadge,
    NapWritPopup,
  },
  props: ["data"],
  data() {
    let objStatus = {};
    switch (this.data.status) {
      case napStatus.APPROVED:
        objStatus = {
          chipColor: "blue",
          btnColor: "gray",
          btnText: "자문서 보기",
          bgColor: "#FAFEFF",
        };
        break;
      default:
        objStatus = {
          chipColor: "green",
          btnColor: "green",
          btnText: "자문서 작성",
          bgColor: "#FAFEFF",
        };
    }

    return {
      isShowNapWritPopup: false,
      objStatus,
    };
  },
  methods: {
    ...mapActions("matching", ["napDelete"]),
    onCloseModal() {
      this.isShowNapWritPopup = false;
    },
    onReply(form) {
      console.log("onReply ===>");
      console.log(form);
      // this.napDelete(params).then(() => {
      //   this.$emit("onReload");
      // });
    },
    handleView() {
      console.log(this.data.status);
      switch (this.data.status) {
        case napStatus.PENDING:
          this.isShowNapWritPopup = true;
          break;
        case napStatus.APPROVED:
          this.isShowNapWritPopup = true;
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// Section 2
</style>
